import React from 'react';

import ActivitySetupStepCoproAdd from '../../components/Analyzing/StepCoproAdd';


function ActivitySetupStepCoproAddView() {
  return (
    <ActivitySetupStepCoproAdd />
  );
}

export default ActivitySetupStepCoproAddView;
